<template>
  <div class="select-tooth">
    <h3 class="brush-map__title">1. Выберите состояние зуба</h3>
    <h4 class="brush-map__subtitle brush-map__subtitle_grey">
      Клик по зубу изменит состояние
    </h4>
    <div class="select-tooth__tooth-status tooth-status_margin">
      <div class="implant-circle"></div>
      <span>Имплант</span>
    </div>
    <!-- tooth-status -->
    <div class="select-tooth__tooth-status">
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="9.14466"
          cy="9.26576"
          r="7.68703"
          stroke="#FA8989"
          stroke-width="1.70823"
        />
        <path
          d="M11.4495 11.8281L6.5843 6.70344M6.84374 11.8281L11.709 6.70344"
          stroke="#FA8989"
          stroke-width="1.70823"
          stroke-linecap="round"
        />
      </svg>
      <span>Отсутствие зуба</span>
    </div>
    <!-- tooth-status -->
  </div>
  <!-- brush-map__select-tooth -->
</template>

<style lang="scss" scoped>
@import '@/apps/styles/resources/index';
@import '@/apps/styles/teeth';

.select-tooth {
  &__tooth-status {
    display: flex;
    align-items: center;
    margin-top: 8px;
    font-family: 'Manrope', sans-serif;
    font-weight: 500;
    font-size: $size--12;
    line-height: 14px;
    gap: 10px;

    &_margin {
      margin-top: 21px;
    }
  }
}

.implant-circle {
  border-radius: 50%;
  width: 17px;
  height: 17px;
  background: #b3b3b3;
}
</style>
